import React from "react";

const seoDataCache = new Map(); // In-memory cache for server context

async function fetchSeoData(slug, pageType) {
  const cacheKey = `${slug}_${pageType}`;

  // ✅ Return cached result if exists
  if (seoDataCache.has(cacheKey)) {
    return seoDataCache.get(cacheKey);
  }

  try {
    if (!process.env.NEXT_PUBLIC_API_BASE_URL) {
      throw new Error("NEXT_PUBLIC_API_BASE_URL is not defined");
    }

    const seoApiUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/getSeoDetails?pageUrl=${slug}&pageType=${pageType}`;
    console.log("Fetching SEO from URL:", seoApiUrl);

    const res = await fetch(seoApiUrl, {
      next: { revalidate: 3600 }, // ISR: revalidate after 1 hour
    });

    const data = await res.json();
    console.log("data SEO from URL:", data);
    const result = data?.data || {};

    // ✅ Store in cache
    seoDataCache.set(cacheKey, result);
    return result;
  } catch (error) {
    console.error(`Error fetching SEO data for ${slug}:`, error);
    return {};
  }
}

const SEOContent = async ({ brandName }) => {
  const slug = brandName?.toLowerCase();
  const seoData = await fetchSeoData(slug, "staticPage");
  const seoContent = seoData?.content;

  if (!seoContent) return null;

  return (
    <div className="border-t-2">
      <div className="max-w-[1440px] px-5 mx-auto py-[20px] SEO">
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: seoContent }}
        />
      </div>
    </div>
  );
};

export default SEOContent;
